import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isTranspose } from '../../utils/coordinate';
import { Funnel } from './funnel';
/**
 * Adjust and return the new `points`.
 */
function getPyramidPoints(points, nextPoints, coordinate) {
  var _points = _slicedToArray(points, 4),
    p0 = _points[0],
    p1 = _points[1],
    p2 = _points[2],
    p3 = _points[3];
  if (isTranspose(coordinate)) {
    var _newP = [nextPoints ? nextPoints[0][0] : (p1[0] + p2[0]) / 2, p1[1]];
    var _newP2 = [nextPoints ? nextPoints[3][0] : (p1[0] + p2[0]) / 2, p2[1]];
    return [p0, _newP, _newP2, p3];
  }
  var newP1 = [p1[0], nextPoints ? nextPoints[0][1] : (p1[1] + p2[1]) / 2];
  var newP2 = [p2[0], nextPoints ? nextPoints[3][1] : (p1[1] + p2[1]) / 2];
  return [p0, newP1, newP2, p3];
}
/**
 * Render pyramid in different coordinate and using color channel for stroke and fill attribute.
 */
export var Pyramid = function Pyramid(options, context) {
  return Funnel(Object.assign({
    adjustPoints: getPyramidPoints
  }, options), context);
};
Pyramid.props = {
  defaultMarker: 'square'
};